import React, {useEffect, useState} from 'react';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import { useLocation, useNavigate } from 'react-router-dom';
import FeedbackTab from './FeedbackTab';
import { useDispatch, useSelector } from 'react-redux';
import { getRating } from 'redux/actions/UserTag';
import moment from 'moment';
import { feedback } from './FeedBackData';

function FeedbackTable() {
  const role = localStorage.getItem('role')
  const dispatch = useDispatch();
  const tableData = useSelector((state) => state?.userRating?.userRating?.data);
  const loader = useSelector((state) => state?.userRating?.loading);
  const [value, setValue] = useState('Customer');
  const [type, setType] = useState('Customer')
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [dateFrom, setDateFrom] = useState(moment(new Date()).format('MM/DD/YYYY'));
  const [dateTo, setDateTo] = useState(moment(new Date()).format('MM/DD/YYYY'));
  const [status, setStatus] = useState("");
  const [statusCard, setStatusCard] = useState("");

  const breadcrumbPaths = [
    
  ];

  let filterData = {
    type:type,
    page:page,
    pageSize:rowsPerPage,
    dateFrom:dateFrom,
    dateTo:dateTo,
    status:status
  }
  let filterDateRange = {
    dateFrom:dateFrom,
    dateTo:dateTo,
  }

  useEffect(() => {
    dispatch(getRating(filterData));
  }, []);


  const location = useLocation();
  const navigate = useNavigate();

  const onClickTableFeedback = (data) => {
    let url = window.location.pathname.split("/")[1]
    if (url === 'feedback'){
      // navigate('/feedback/details?tripId='+data?.Trip?.id+'&type='+type)
      navigate('/feedback/details', {state: {tripId: data?.Trip?.id, type}})
    }
  }

  const handleChange = (newValue) => {
    setValue(newValue)
    setType(newValue)
    dispatch(getRating({...filterData, type:newValue}));
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getRating({...filterData, page:newPage}))
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(getRating({...filterData, page:0, pageSize:parseInt(event.target.value)}))
  };

  const onSelectDateRange = (newValue) => {
    if(newValue === null){
      setDateFrom('')
      setDateTo('')
      filterData = {...filterData, 
        dateFrom:'',
        dateTo:'',
        page:0
      }
    }else{
      setDateFrom(moment(newValue[0]).format("MM/DD/YYYY"))
      setDateTo(moment(newValue[1]).format("MM/DD/YYYY"))
      filterData = {...filterData, 
        dateFrom:moment(newValue[0]).format("MM/DD/YYYY"),
        dateTo:moment(newValue[1]).format("MM/DD/YYYY"),
        page:0
      }
    }
    dispatch(getRating(filterData));
  }

  const onFilterChange = (val) => {
    setStatus(val);
    setPage(0);
    setStatusCard('')
    filterData = {...filterData, page: 0, status: val}
    dispatch(getRating(filterData));
  }

  const onRestFilter = () => {
    setStatus("")
    setStatusCard('')
    filterData = {...filterData, status:""}
    dispatch(getRating(filterData));
  }

  const onRating = (rating) => {
    if(rating === statusCard){
      setStatusCard('')
      filterData = {...filterData, page: 0, status: ''}
    }else{
      setStatusCard(rating)
      filterData = {...filterData, page: 0, status: rating}
    }
    setPage(0);
    setStatus("");
    dispatch(getRating(filterData));
  }

  return (
    <div>
        <CommonBreadCrumb paths={breadcrumbPaths}/>
        
        <FeedbackTab
          tabName={"feedback"}
          isLoading={loader}
          defaultStatus={status}
          filterData={feedback}
          onFilterChange={onFilterChange} 
          onRestFilter={onRestFilter} 
          tableData={tableData} 
          onClickTableFeedback={onClickTableFeedback}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          value={value}
          role={role}
          onSelectDateRange={onSelectDateRange}
          handleChange={handleChange}
          onRating={onRating}
          status={statusCard}
        />
    </div>
  )
}

export default FeedbackTable;